import React from 'react'
import { Popup, Icon } from 'semantic-ui-react'

export const Tooltip = (props:any) => {
  return (
    <div style={{marginLeft: '5px', display: 'inline-block'}}>
      <Popup content={props.children} hoverable basic trigger={<Icon name="question" size="small" color="grey" circular/>}/>
    </div>
  );
}

export default Tooltip
